import { reactive, readonly } from 'vue';

export type ToastKind = 'info' | 'success' | 'error';

export interface Toast {
    id: number;
    kind: ToastKind;
    message: string;
}

interface State {
    toasts: Toast[];
}

const state = reactive<State>({ toasts: [] });
let nextId = 1;

function push(message: string, kind: ToastKind, ttlMs: number): number {
    const id = nextId++;
    state.toasts.push({ id, kind, message });
    if (ttlMs > 0) {
        setTimeout(() => dismiss(id), ttlMs);
    }
    return id;
}

function dismiss(id: number): void {
    const idx = state.toasts.findIndex((t) => t.id === id);
    if (idx >= 0) state.toasts.splice(idx, 1);
}

/**
 * Hook único — todos os componentes compartilham o mesmo state.
 *
 * Uso:
 *   const { error, success, info } = useToast();
 *   error('Não foi possível salvar agora.');
 */
export function useToast() {
    return {
        toasts: readonly(state.toasts),
        info: (msg: string, ttl = 4000) => push(msg, 'info', ttl),
        success: (msg: string, ttl = 3500) => push(msg, 'success', ttl),
        error: (msg: string, ttl = 5000) => push(msg, 'error', ttl),
        dismiss,
    };
}
